import { faPagelines } from "@fortawesome/free-brands-svg-icons";
import {
  faCopy,
  faEnvelope,
  faInfo,
  faInfoCircle,
  faQuestionCircle,
  faShoppingCart,
  faStore,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import PromoImage from "../../assets/images/APW_Promo.jpg";
import CreatePrescriptionIcon from "../../assets/images/create_prescription_icon.png";
import PatientIcon from "../../assets/images/patients.png";
import PrescriptionIcon from "../../assets/images/prescriptions_icon.png";
import DashboardCardItem from "../../components/DashBoardCardItem";
import Fullscript from "../../assets/images/fullscript.svg";
import FullscriptDashboardItem from "../../components/FullScriptDashboartItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import history from "../../utils/history";
const Dashboard = () => {
  const role = useSelector((state) => state.role.role);
  const dispatch = useDispatch();
  const notification = useSelector((state) => state.dashboard.notification);

  const getItems = (role) => {
    if (role?.val === 3) {
      return (
        <>
          <DashboardCardItem
            horizontal
            text="Prescriptions"
            description="See pending refill requests and access your prescription history."
            type="image"
            icon={PrescriptionIcon}
            path="/app/prescriptions"
            notification={notification.num_unordered_rxs}
          />
          <DashboardCardItem
            horizontal
            text="Practitioners"
            description="View Practitioners, make new ones, or delete old ones."
            type="image"
            icon={PatientIcon}
            path="/app/practitioners"
            notification={notification.num_pending_practitioner}
          />
          <DashboardCardItem
            horizontal
            text="Order History"
            description="Access your list of purchased orders."
            icon={faCopy}
            path="/app/orders"
          />

          <DashboardCardItem
            horizontal
            text="Profile"
            description="View and edit your public and private information."
            icon={faUser}
            path="/app/profile"
          />

          {/* <DashboardCardItem
            horizontal
            text="Store"
            description="View our products and add to cart."
            icon={faStore}
            path="/app/store"
          /> */}

          <DashboardCardItem
            horizontal
            text="Shopping Cart"
            description="View items in your cart."
            icon={faShoppingCart}
            path="/app/shopping"
            notification={notification.num_cart_items}
          />
        </>
      );
    } else if (role?.val === 4) {
      return (
        <>
          <DashboardCardItem
            text="Create Prescription"
            description="Create new prescriptions for your patients."
            type="image"
            icon={CreatePrescriptionIcon}
            path="/app/prescription"
          />
          <DashboardCardItem
            text="Prescriptions"
            description="See pending refill requests and access your prescription history."
            type="image"
            icon={PrescriptionIcon}
            path="/app/prescriptions"
            notification={notification.num_refill_request}
          />
          <DashboardCardItem
            text="Patients"
            description="Manage your patients by viewing, adding, or removing old ones. Accept requests from new patients."
            type="image"
            icon={PatientIcon}
            path={"/app/patients"}
            notification={notification.num_pending_patient}
          />
          <DashboardCardItem
            text="Your Formulas"
            description="Create new formulas or edit your custom  formulas."
            icon={faPagelines}
            path="/app/formulas"
          />
          <DashboardCardItem
            horizontal
            text="Order History"
            description="Access your list of purchased orders."
            icon={faCopy}
            path="/app/orders"
          />

          <DashboardCardItem
            horizontal
            text="Profile"
            description="View and edit your public and private information."
            icon={faUser}
            path="/app/profile"
          />

          {/* <DashboardCardItem
            horizontal
            text="Store"
            description="View our products and add to cart."
            icon={faStore}
            path="/app/store"
          /> */}

          <DashboardCardItem
            horizontal
            text="Shopping Cart"
            description="View items in your cart."
            icon={faShoppingCart}
            path="/app/shopping"
            notification={notification.num_cart_items}
          />
        </>
      );
    } else {
      return (
        <>
          <DashboardCardItem
            text="Create Prescription"
            description="Create new prescriptions for your patients."
            type="image"
            icon={CreatePrescriptionIcon}
            path="/app/prescription"
          />
          <DashboardCardItem
            text="Prescriptions"
            description="See pending refill requests and access your prescription history."
            type="image"
            icon={PrescriptionIcon}
            path="/app/prescriptions"
            notification={notification.num_refill_request}
          />
          <DashboardCardItem
            text="Patients"
            description="Manage your patients by viewing, adding, or removing old ones. Accept requests from new patients."
            type="image"
            icon={PatientIcon}
            path={"/app/patients"}
            notification={notification.num_pending_patient}
          />
          <DashboardCardItem
            text="Your Formulas"
            description="Create new formulas or edit your custom  formulas."
            icon={faPagelines}
            path="/app/formulas"
          />
          <DashboardCardItem
            horizontal
            text="Order History"
            description="Access your list of purchased orders."
            icon={faCopy}
            path="/app/orders"
          />

          <DashboardCardItem
            horizontal
            text="Profile"
            description="View and edit your public and private information."
            icon={faUser}
            path="/app/profile"
          />
          {/* 
          <DashboardCardItem
            horizontal
            text="Store"
            description="View our products and add to cart."
            icon={faStore}
            path="/app/store"
          /> */}

          <DashboardCardItem
            horizontal
            text="Shopping Cart"
            description="View items in your cart."
            icon={faShoppingCart}
            path="/app/shopping"
            notification={notification.num_cart_items}
          />
        </>
      );
    }
  };

  return (
    <div className="dashboard-container">
      <div className="inner-wrapper">
        <div className="row">
          {role && getItems(role)}
          <DashboardCardItem
            horizontal
            text="Contact"
            description="View our contact information and map. Send us a message."
            icon={faEnvelope}
            path="/app/contact"
          />
          {/* <DashboardCardItem
            horizontal
            text="FAQs"
            description="Get answers to commonly asked Practitioner questions and technical support."
            icon={faQuestionCircle}
            path="/app/faq"
          /> */}
        </div>
      </div>
      {role?.val === 4 && (
        <div className="dashboard-message">
          <FontAwesomeIcon icon={faInfoCircle} color="#f79225" />
          <p>
            If you are no longer a student and wish to upgrade your account to a
            practitioner, you can do so on the{" "}
            <span onClick={() => history.push("/app/profile")}>
              profile page
            </span>
            .
          </p>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
